(function(){
  var root=document.querySelector('.m5b:not([data-ready="true"])');
  if(!root||root.dataset.ready==='true')return;
  root.dataset.ready='true';

  var limit=Number(root.dataset.limit)||5;
  var selected=[];
  var filter='all';
  var cards=Array.prototype.slice.call(root.querySelectorAll('.m5b__card'));
  var search=root.querySelector('.m5b__search input');
  var counter=root.querySelector('.m5b__counter');
  var dots=root.querySelectorAll('.m5b__dots i');
  var list=root.querySelector('.m5b__selected');
  var add=root.querySelector('.m5b__add');
  var message=root.querySelector('.m5b__message');

  function render(){
    counter.textContent=selected.length+' / '+limit+' seçildi';
    Array.prototype.forEach.call(dots,function(dot,i){dot.classList.toggle('is-filled',i<selected.length);});
    list.innerHTML='';
    selected.forEach(function(card){var li=document.createElement('li'),b=document.createElement('button');li.append(card.dataset.title,b);b.type='button';b.textContent='×';b.setAttribute('aria-label',card.dataset.title+' seçimini kaldır');b.style.cssText='border:0;background:none;color:#666;font-size:18px;line-height:1;margin:-6px -4px -6px 4px;padding:6px;cursor:pointer';b.addEventListener('click',function(){selected.splice(selected.indexOf(card),1);card.querySelector('.m5b__pick').setAttribute('aria-pressed','false');render();});list.appendChild(li);});
    add.disabled=selected.length!==limit;
    message.textContent=selected.length===limit?'Setin hazır! Sepete ekleyebilirsin.':'Hediye kokun için '+(limit-selected.length)+' koku daha seç.';
  }

  function applyFilter(){
    var q=(search.value||'').toLocaleLowerCase('tr-TR').trim();
    var visible=0;
    cards.forEach(function(card){
      var okGender=filter==='all'||card.dataset.gender===filter;
      var okSearch=!q||card.dataset.name.indexOf(q)>-1;
      card.hidden=!(okGender&&okSearch);
      if(!card.hidden)visible++;
    });
    root.querySelector('.m5b__empty').hidden=visible!==0;
  }

  root.querySelectorAll('[data-filter]').forEach(function(btn){
    btn.addEventListener('click',function(){
      filter=btn.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(function(b){b.classList.toggle('is-active',b===btn);});
      applyFilter();
    });
  });

  search.addEventListener('input',applyFilter);

  cards.forEach(function(card){
    card.querySelector('.m5b__pick').addEventListener('click',function(){
      var i=selected.indexOf(card);
      if(i>-1){selected.splice(i,1);this.setAttribute('aria-pressed','false');}
      else if(selected.length<limit){selected.push(card);this.setAttribute('aria-pressed','true');}
      else{
        message.textContent='En fazla '+limit+' koku seçebilirsin.';
        message.classList.add('is-error');
        setTimeout(function(){message.classList.remove('is-error');render();},1800);
        return;
      }
      render();
    });
  });

  function request(url,body){
    return fetch(window.Shopify.routes.root+url,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(response){
      return response.json().then(function(data){
        if(!response.ok)throw new Error(data.description||data.message||'Sepete eklenemedi');
        return data;
      });
    });
  }

  add.addEventListener('click',function(){
    if(selected.length!==limit)return;
    add.disabled=true;
    add.textContent='Ekleniyor...';
    message.textContent='';
    message.classList.remove('is-error');

    var variantId=String(root.dataset.productId);
    var properties={};
    selected.forEach(function(card,i){properties['Koku '+(i+1)]=card.dataset.title+' – 5 ML';});
    properties['Set İçeriği']=selected.map(function(card){return card.dataset.title;}).join(', ');

    fetch(window.Shopify.routes.root+'cart.js',{headers:{'Accept':'application/json'}})
      .then(function(response){if(!response.ok)throw new Error('Sepet okunamadı');return response.json();})
      .then(function(cart){
        var existing=cart.items.find(function(item){return String(item.variant_id)===variantId;});
        if(existing){
          return request('cart/change.js',{id:existing.key,quantity:1,properties:properties});
        }
        return request('cart/add.js',{items:[{id:Number(variantId),quantity:1,properties:properties}]});
      })
      .then(function(){window.location.href=window.Shopify.routes.root+'cart';})
      .catch(function(error){
        add.disabled=false;
        add.textContent=root.dataset.buttonText;
        message.textContent=error.message||'Sepete eklenemedi. Lütfen tekrar dene.';
        message.classList.add('is-error');
      });
  });

  render();
  applyFilter();
})();